/**
 * @generated SignedSource<<45de6dac49516d059c113811b248c117>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storeCatalogQuery$variables = {
  salesChannelID: string;
};
export type storeCatalogQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"storeCatalogPaginationFragment__merchantProducts">;
};
export type storeCatalogQuery = {
  response: storeCatalogQuery$data;
  variables: storeCatalogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = {
  "kind": "Variable",
  "name": "salesChannelID",
  "variableName": "salesChannelID"
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "search",
    "value": ""
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "storeCatalogQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "storeCatalogPaginationFragment__merchantProducts"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "storeCatalogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MerchantProductsConnection",
        "kind": "LinkedField",
        "name": "merchantProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MerchantProductsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MerchantProduct",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sku",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isConfiguratedInZakeke",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "search",
          "salesChannelID"
        ],
        "handle": "connection",
        "key": "storeCatalogPaginationFragment_merchantProducts",
        "kind": "LinkedHandle",
        "name": "merchantProducts"
      }
    ]
  },
  "params": {
    "cacheID": "c01be23522a0ea39d05fd82b7383f782",
    "id": null,
    "metadata": {},
    "name": "storeCatalogQuery",
    "operationKind": "query",
    "text": "query storeCatalogQuery(\n  $salesChannelID: ID!\n) {\n  ...storeCatalogPaginationFragment__merchantProducts_2P2j2V\n}\n\nfragment storeCatalogPaginationFragment__merchantProducts_2P2j2V on Query {\n  merchantProducts(first: 20, search: \"\", salesChannelID: $salesChannelID) {\n    edges {\n      node {\n        sku\n        name\n        thumbnail\n        isConfiguratedInZakeke\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e962e1e1f30e464f08a2d83126bcd3d";

export default node;
